import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '../../core/notifications.service';
import { FeedbackService } from '../feedback.service';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
})
export class NotificationsComponent implements OnInit {
  public notifications: any;
  public feedbackView: any;
  public featureBanner = false;

  constructor(
    private feedbackService: FeedbackService,
    private notificationsService: NotificationsService,
    private userService: UserService,
  ) {}

  public ngOnInit(): void {
    this.notifications = this.notificationsService.settings;
    const plantypeId = this.userService.get('plantype_id');
    this.featureBanner =
      plantypeId && plantypeId > 1 && localStorage.getItem('collaborativeLinks') == 'true' ? true : false;
    this.feedbackView = this.feedbackService.view;
    this.notificationsService.startNotificationLoop();
  }

  public restartNotifications(): Promise<void> {
    return this.notificationsService.startNotificationLoop();
  }

  public closeFeedback(key?: string): void {
    if (key == 'collaborativeLinks') {
      this.featureBanner = false;
      localStorage.removeItem('collaborativeLinks');
      return;
    } // Close specific notification
    return this.feedbackService.hideFeedback();
  }
}
